import { V2L3DevTokenModal } from "@fusion-advantage/formrender"
import { useAppSelector, useAppDispatch } from "../../../redux/hooks"
import { useEffect, useState } from "react"
import { apiMgrTokenEcho } from "../../../redux/apithunk/apiMgr"
import { AppModal, dismissAppModal } from "../../../redux/appSlice"

export const LxDevTokenModal = () => {
	const loading = useAppSelector(state => Boolean(state.app.ldng.apiMgrTokenEcho))
	const bearerToken = useAppSelector(state => state.app.bearerToken)
	const [token, setToken] = useState<string|null>(null)
	const dispatch = useAppDispatch()
	useEffect(() => {
		(async () => {
			if(bearerToken) {
				setToken(bearerToken.token)
			} else {
				const rToken = await dispatch(apiMgrTokenEcho())
				if(rToken.isErr()) {
					// error message already displayed
					dispatch(dismissAppModal(AppModal.DevToken))
					return
				}
				setToken(rToken.value.Token)
			}
		})()
	}, [bearerToken, dispatch, setToken])
	return (
		<V2L3DevTokenModal
			loading={loading}
			token={token}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.DevToken))}
		/>
	)
}
